import Extension from "../base/extension";

class Nav extends Extension {
  #section;

  constructor(name) {
    super(name);
  }

  init() {
    this.#section = document.querySelector('.section-header');
    this.setupScrollListener();
    this.setupMegamenuOverlay();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
  }

  setupMegamenuOverlay() {
    const navbar = document.getElementById('navbar');
    if (!navbar) return;
    const items = navbar.querySelectorAll('li.dropdown-hover');
    const dropdownItems = Array.prototype.filter.call(items, (li) => li.querySelector('.dropdown-menu'));
    if (!dropdownItems.length) return;
    dropdownItems.forEach((li) => {
      li.addEventListener('mouseenter', () => navbar.classList.add('megamenu-open'));
      li.addEventListener('mouseleave', () => navbar.classList.remove('megamenu-open'));
    });
  }

  onScrollDown(e) {
    if(e.detail.difference > 5) {
      this.#section.classList.remove('scrolled-up');
      this.#section.classList.add('scrolled-down');
    }
  }

  onScrollUp(e) {
    if(e.detail.difference > 5) {
      this.#section.classList.remove('scrolled-down');
      this.#section.classList.add('scrolled-up');
    }
  }

  setupScrollListener() {
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.addEventListener("scroll", function(e){
      let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      let difference = Math.abs(st - lastScrollTop);
      // Add a 'tolerance' to prevent microscrolls from retriggering (e.g. on touch devices, there's usually a very small scroll up after scrolling down)
      if (st > lastScrollTop){
        let event = new CustomEvent("interaction:down-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      } else {
        let event = new CustomEvent("interaction:up-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
  }
}

export default Nav;